// The window's size in CSS pixels, kept current on resize. The sky stage is
// laid out from it so its sky units match the board's (1000 per height).
import { useEffect, useState } from 'react';

export interface ViewSize {
  width: number;
  height: number;
}

function measure(): ViewSize {
  return typeof window === 'undefined' ? { width: 1440, height: 900 } : { width: window.innerWidth, height: window.innerHeight };
}

export function useViewSize(): ViewSize {
  const [size, setSize] = useState(measure);
  useEffect(() => {
    const update = () =>
      setSize((s) => {
        const next = measure();
        return next.width === s.width && next.height === s.height ? s : next;
      });
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return size;
}
